<template>
    <AppLayout>
        <template #subheader>
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center gap-3 flex-wrap">
                    <div class="d-flex align-items-center gap-2">
                        <label for="project-select" class="mb-0">Projekt:</label>
                        <select
                            id="project-select"
                            class="form-select form-select-sm"
                            v-model.number="selectedProjectId"
                            @change="updateSelectedProject"
                            style="min-width: 240px; max-width: 1000px;">
                            <option :value="0">Wybierz projekt</option>
                            <option v-for="project in projects"
                                :key="project.id"
                                :value="project.id">
                                {{ project.label }}
                            </option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center gap-2 me-5">
                        <label for="team-select" class="mb-0">Zespół:</label>
                        <select
                            id="team-select"
                            class="form-select form-select-sm"
                            v-model.number="selectedTeamId"
                            @change="updateSelectedTeam"
                            :disabled="!selectedProjectId || teams.length === 0"
                            style="min-width: 240px;">
                            <option :value="0">Wszystkie zespoły</option>
                            <option
                                v-for="team in teams"
                                :key="team.id"
                                :value="team.id">
                                {{ team.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <div class="widget-heading">
                    <div class="row align-items-center">
                        <div class="col d-flex align-items-center">
                            <h4 class="me-3 my-0">Lista produkcji</h4>
                        </div>
                    </div>
                </div>

                <div class="widget-content">
                    <div
                        v-if="!selectedProjectId"
                        class="alert alert-light border mt-3">
                        Wybierz projekt, aby wyświetlić dane.
                    </div>

                    <template v-else>
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <input
                                    v-model="searchQuery"
                                    class="form-control form-sm"
                                    placeholder="Szukaj...">
                            </div>
                            <div class="col-md-8 text-end">
                                <label>
                                    Liczba rekordów na stronie:
                                </label>
                                <select
                                    v-model.number="pageSize"
                                    class="form-select form-sm d-inline w-auto ms-2">
                                    <option
                                        v-for="size in pageSizeOptions"
                                        :key="size"
                                        :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div
                            v-if="paginatedCheckProduction.length > 0"
                            class="table-responsive">
                            <table
                                id="production-out-table"
                                class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th
                                            @click="changeSort('display_name')"
                                            style="cursor:pointer;">
                                            Nazwa
                                            <i
                                                v-if="sortColumn === 'display_name'"
                                                :class="sortDirection === 'asc'
                                                    ? 'bi bi-arrow-up'
                                                    : 'bi bi-arrow-down'"></i>
                                        </th>
                                        <th>Utworzył</th>
                                        <th
                                            @click="changeSort('created_at')"
                                            style="cursor:pointer;">
                                            Utworzono
                                            <i
                                                v-if="sortColumn === 'created_at'"
                                                :class="sortDirection === 'asc'
													? 'bi bi-arrow-up'
													: 'bi bi-arrow-down'">
                                            </i>
                                        </th>
                                        <th>Akcje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(checkproduction, pid) in paginatedCheckProduction"
                                        :key="checkproduction.id">
                                        <td>
                                            {{ pid + 1 + (currentPage - 1) * pageSize }}
                                        </td>
                                        <td>
                                            <span class="production-name">
                                                {{ getDisplayName(checkproduction) }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ getCreatedByName(checkproduction) }}
                                        </td>
                                        <td>
                                            {{ formatDate(checkproduction.created_at) }}
                                        </td>
                                        <td>
                                            <a
                                                :href="route('check_production.show', {
                                                    id: checkproduction.id
                                                })"
                                                class="btn btn-info btn-sm">
                                                <i class="bi bi-box-arrow-in-right"></i>
                                                &nbsp;Przejdź
                                            </a>
                                            <button
                                                type="button"
                                                class="btn btn-danger btn-sm ms-2"
                                                @click="deleteCheckProduction(checkproduction.id)">
                                                <i class="bi bi-trash"></i>
                                                &nbsp;Usuń
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div
                            v-else
                            class="alert alert-light border mt-3">
                            <template v-if="selectedTeamId">
                                Brak pozycji dla wybranego projektu i zespołu.
                            </template>
                            <template v-else>
                                Brak pozycji dla wybranego projektu.
                            </template>
                        </div>

                        <nav
                            v-if="totalPages > 1"
                            aria-label="Page navigation">
                            <ul class="pagination justify-content-center mt-3">
                                <li
                                    class="page-item"
                                    :class="{ disabled: currentPage === 1 }">
                                    <a
                                        class="page-link"
                                        href="#"
                                        @click.prevent="changePage(currentPage - 1)">
                                        Poprzednia
                                    </a>
                                </li>

                                <li
                                    v-for="page in totalPages"
                                    :key="page"
                                    class="page-item"
                                    :class="{ active: page === currentPage }">
                                    <a
                                        class="page-link"
                                        href="#"
                                        @click.prevent="changePage(page)">
                                        {{ page }}
                                    </a>
                                </li>

                                <li
                                    class="page-item"
                                    :class="{ disabled: currentPage === totalPages }">
                                    <a
                                        class="page-link"
                                        href="#"
                                        @click.prevent="changePage(currentPage + 1)">
                                        Następna
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </template>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from "@/Layouts/App.vue";
    import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";

    export default {
        components: {
            AppLayout
        },

        props: {
            projects: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                selectedProjectId: 0,
                selectedTeamId: 0,
                checkProduction: [],
                teams: [],
                searchQuery: '',
                currentPage: 1,
                pageSizeOptions: [10, 20, 50, 100],
                pageSize: 10,
                sortColumn: 'display_name',
                sortDirection: 'asc',
                isCreating: false,
                loading: false
            };
        },

        computed: {
            canCreate() {
                return (
                    Number(this.selectedProjectId) > 0 &&
                    Number(this.selectedTeamId) > 0 &&
                    this.checkProduction.length === 0 &&
                    !this.loading
                );
            },

            filteredCheckProduction() {
                let data = [...this.checkProduction];

                if (this.searchQuery.trim()) {
                    const query = this.searchQuery.trim().toLowerCase();

                    data = data.filter(item =>
                        this.getDisplayName(item)
                        .toLowerCase()
                        .includes(query)
                    );
                }

                return data;
            },

            sortedCheckProduction() {
                const data = [...this.filteredCheckProduction];

                if (!this.sortColumn) {
                    return data;
                }

                return data.sort((a, b) => {
                    let valA;
                    let valB;

                    if (this.sortColumn === 'display_name') {
                        valA = this.getDisplayName(a).toLowerCase();
                        valB = this.getDisplayName(b).toLowerCase();
                    } else {
                        valA = String(a[this.sortColumn] ?? '').toLowerCase();
                        valB = String(b[this.sortColumn] ?? '').toLowerCase();
                    }

                    if (valA < valB) {
                        return this.sortDirection === 'asc' ? -1 : 1;
                    }

                    if (valA > valB) {
                        return this.sortDirection === 'asc' ? 1 : -1;
                    }

                    return 0;
                });
            },

            paginatedCheckProduction() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;

                return this.sortedCheckProduction.slice(start, end);
            },

            totalPages() {
                return Math.ceil(
                    this.sortedCheckProduction.length / this.pageSize
                );
            }
        },

        watch: {
            pageSize() {
                this.adjustCurrentPage();
            },

            filteredCheckProduction() {
                this.currentPage = 1;
                this.adjustCurrentPage();
            }
        },

        mounted() {
            const savedProjectId = Number(
                localStorage.getItem('checkProductionProjectId') || 0
            );

            const savedTeamId = Number(
                localStorage.getItem('checkProductionTeamId') || 0
            );

            const projectExists = this.projects.some(
                project => Number(project.id) === savedProjectId
            );

            if (!projectExists) {
                localStorage.removeItem('checkProductionProjectId');
                localStorage.removeItem('checkProductionTeamId');
                return;
            }

            this.selectedProjectId = savedProjectId;
            this.updateTeams();

            const teamExists = this.teams.some(
                team => Number(team.id) === savedTeamId
            );

            this.selectedTeamId = teamExists ? savedTeamId : 0;

            if (this.selectedProjectId) {
                this.loadFilteredData();
            }
        },

        methods: {

            getCreatedByName(item) {
                const user = item?.created_by_user;

                if (!user) {
                    return '';
                }

                return [user.first_name, user.last_name]
                    .filter(Boolean)
                    .join(' ');
            },

			deleteCheckProduction(id) {
				Toast.fire({
					toast: false,
					icon: 'warning',
					title: 'Usuwanie wpisu',
					html: 'Czy na pewno chcesz usunąć wybraną pozycję i wszystkie jej dane?',
					showDenyButton: true,
					showConfirmButton: true,
					confirmButtonText: 'Tak',
					denyButtonText: 'Nie',
					timer: false,
					position: 'center'
				}).then((result) => {

					if (!result.isConfirmed) {
						return;
					}

					const csrfToken = document
						.querySelector('meta[name="csrf-token"]')
						.getAttribute('content');

					fetch(route('check_production.destroy', id), {
						method: 'DELETE',
						headers: {
							'X-CSRF-TOKEN': csrfToken,
							'Accept': 'application/json',
							'Content-Type': 'application/json'
						}
					})
					.then(async (response) => {
						const data = await response.json();

						if (!response.ok) {
							throw new Error(
								data.message || 'Nie można usunąć pozycji.'
							);
						}

						return data;
					})
					.then((data) => {

						Toast.fire({
							icon: 'success',
							title: data.message
						});

						this.loadFilteredData();

					})
					.catch((error) => {

						Toast.fire({
							icon: 'error',
							title: error.message
						});

					});
				});
			},

			getDisplayName(item) {
                if (!item) {
                    return '';
                }

                const project = item.project;
                const team = item.team;

                const projectName = `${project.number}`;
                const teamName = team.team_name_construction || team.name;
                return `${projectName}-${teamName}`;
            },

            updateSelectedProject() {
                this.selectedTeamId = 0;
                this.teams = [];
                this.checkProduction = [];
                this.searchQuery = '';
                this.currentPage = 1;

                localStorage.setItem(
                    'checkProductionProjectId',
                    String(this.selectedProjectId)
                );

                localStorage.setItem(
                    'checkProductionTeamId',
                    '0'
                );

                this.updateTeams();

                if (Number(this.selectedProjectId) > 0) {
                    this.loadFilteredData();
                }
            },

            updateTeams() {
                if (!Number(this.selectedProjectId)) {
                    this.teams = [];
                    return;
                }

                const project = this.projects.find(
                    project =>
                    Number(project.id) ===
                    Number(this.selectedProjectId)
                );

                this.teams = project?.teams || [];
            },

            updateSelectedTeam() {
                this.checkProduction = [];
                this.searchQuery = '';
                this.currentPage = 1;

                localStorage.setItem(
                    'checkProductionProjectId',
                    String(this.selectedProjectId)
                );

                localStorage.setItem(
                    'checkProductionTeamId',
                    String(this.selectedTeamId)
                );

                if (Number(this.selectedProjectId) > 0) {
                    this.loadFilteredData();
                }
            },

            async loadFilteredData() {
                if (!Number(this.selectedProjectId)) {
                    this.checkProduction = [];
                    return;
                }

                this.loading = true;

                try {
                    const params = new URLSearchParams();

                    params.append(
                        'project_id',
                        Number(this.selectedProjectId)
                    );

                    params.append(
                        'team_id',
                        Number(this.selectedTeamId) || 0
                    );

                    const response = await fetch(
                        route('check_production.filter') +
                        '?' +
                        params.toString(), {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            credentials: 'same-origin'
                        }
                    );

                    if (!response.ok) {
                        throw new Error(
                            `Błąd pobierania danych: ${response.status}`
                        );
                    }

                    const data = await response.json();

                    this.checkProduction = Array.isArray(data) ?
                        data : [];

                    this.currentPage = 1;
                } catch (error) {
                    console.error(
                        'Błąd pobierania CheckProduction:',
                        error
                    );

                    this.checkProduction = [];

                    Toast.fire({
                        icon: 'error',
                        title: 'Nie udało się pobrać danych.'
                    });
                } finally {
                    this.loading = false;
                }
            },

            createCheckProduction() {
                if (
                    !Number(this.selectedProjectId) ||
                    !Number(this.selectedTeamId)
                ) {
                    Toast.fire({
                        icon: 'warning',
                        title: 'Wybierz projekt i zespół.'
                    });

                    return;
                }

                this.isCreating = true;

                this.$inertia.post(
                    route('check_production.store'), {
                        project_id: Number(this.selectedProjectId),
                        team_id: Number(this.selectedTeamId)
                    }, {
                        preserveScroll: true,

                        onSuccess: () => {
                            this.loadFilteredData();
                        },

                        onError: () => {
                            Toast.fire({
                                icon: 'error',
                                title: 'Nie udało się utworzyć pozycji.'
                            });
                        },

                        onFinish: () => {
                            this.isCreating = false;
                        }
                    }
                );
            },

            changePage(page) {
                if (page < 1 || page > this.totalPages) {
                    return;
                }

                this.currentPage = page;
            },

            changeSort(column) {
                if (this.sortColumn === column) {
                    this.sortDirection =
                        this.sortDirection === 'asc' ?
                        'desc' :
                        'asc';
                } else {
                    this.sortColumn = column;
                    this.sortDirection = 'asc';
                }
            },

            adjustCurrentPage() {
                const totalPages = Math.ceil(
                    this.sortedCheckProduction.length /
                    this.pageSize
                );

                if (this.currentPage > totalPages) {
                    this.currentPage = totalPages || 1;
                }
            },

            formatDate(date) {
                if (!date) {
                    return '';
                }

                const value = String(date).substring(0, 10);
                const [year, month, day] = value.split('-');

                if (!year || !month || !day) {
                    return '';
                }

                return `${day}.${month}.${year}`;
            }
        }
    };
</script>

<style scoped>
    #production-out-table th {
        font-weight: 600;
    }

    .production-name {
        font-weight: 500;
    }
</style>